var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trip-textarea"},[_c('p',{staticClass:"ride-detailes",domProps:{"innerHTML":_vm._s(_vm.ride.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }